/******/ (() => {
if (!customElements.get('out-of-stock-form')) {
  customElements.define('out-of-stock-form',
  class OutOfStockForm extends HTMLElement {
    connectedCallback() {
      const form = document.getElementById('out-of-stock-contact-form');
      const submitBtn = this.querySelector('button[type="submit"]');
      const emailInput = this.querySelector('input[type="email"]');
      if (!form || !submitBtn || !emailInput || this.dataset.ready) return;
      this.dataset.ready = 'true';

      const originalText = submitBtn.textContent;
      const pTag = this.querySelector('p');

      let frame = document.getElementById('oos-result-frame');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.id = 'oos-result-frame';
        frame.name = 'oos-result-frame';
        frame.style.display = 'none';
        frame.setAttribute('aria-hidden', 'true');
        document.body.appendChild(frame);
      }
      form.target = 'oos-result-frame';

      let waiting = false;

      const showThanks = () => {
        submitBtn.textContent = 'Thank You!';
        submitBtn.disabled = true;
        emailInput.style.display = 'none';
        if (pTag) pTag.style.display = 'none';
      };

      const showError = () => {
        submitBtn.textContent = 'Something went wrong – try again';
        submitBtn.disabled = false;
        emailInput.style.display = '';
        if (pTag) pTag.style.display = '';
        setTimeout(() => { submitBtn.textContent = originalText; }, 4000);
      };

      submitBtn.addEventListener('click', () => {
        if (!emailInput.checkValidity()) return;
        waiting = true;
        setTimeout(showThanks, 50);
      });

      frame.addEventListener('load', () => {
        if (!waiting) return;
        waiting = false;
        try {
          const href = frame.contentWindow.location.href;
          const title = frame.contentDocument ? frame.contentDocument.title : '';
          if (href.includes('/challenge') || /captcha|went wrong|error/i.test(title)) {
            console.error('Form submission error:', href, title);
            showError();
          }
        } catch (e) {}
      });
    }
  });
}
/******/ })();